/*
 *   File : radio-group.js
 *   Author URI : https://evoqins.com
 *   Description : Radio button component
 *   Integrations : NA
 *   Version : v1.1
 */

//assets
import Select from "../../Assets/Image/ManageBasket/Subtract.svg";
import Unselect from "../../Assets/Image/ManageBasket/Plate.svg";

import type2Select from "../../Assets/Image/radio-button-type-2-selected.svg";
import type2UnSelect from "../../Assets/Image/radio-button-typ-2-unselected.svg";

function RadioGroup(props) {
  const { data, selectedItem, onSelectItem } = props;

  const handleRadioItemClick = (selected_id) => {
    onSelectItem(selected_id);
  };

  return (
    <div>
      {props.label && (
        <label
          className={
            props.labelStyle
              ? props.labelStyle
              : "e-text-black e-primary-font-poppins  e-font-weight-500  e-font-14 pb-1"
          }
        >
          {props.label}
          {props.require && <span className="text-danger">*</span>}
        </label>
      )}
      <div
        className={`${props.className} d-flex align-items-center gap-4 flex-wrap pb-3`}
      >
        {data.map((item, key) => (
          <div
            className="d-flex align-items-center e-radio e-cursor-pointer"
            onClick={() => handleRadioItemClick(item.value)}
            key={key}
          >
            <div className="text-start">
              <img
                width={props.type === 2 ? 21 : 16}
                height={props.type === 2 ? 21 : 16}
                draggable="false"
                src={
                  props.type === 2
                    ? selectedItem === item.value
                      ? type2Select
                      : type2UnSelect
                    : selectedItem === item.value
                    ? Select
                    : Unselect
                }
                alt="radio-btn"
              />
            </div>
            {props.type === 2 ? (
              <span
                className={`e-radio-span e-primary-font-poppins e-font-16 e-font-weight-400 e-text-eerie-black  ms-2 cursor-pointer pt-1`}
              >
                {item.label}
              </span>
            ) : (
              <span
                className={`e-radio-span e-primary-font-poppins e-font-12 e-font-weight-500 ${
                  selectedItem === item.value
                    ? "e-text-black"
                    : "e-text-gray-x11"
                }  ms-2 cursor-pointer pt-1`}
              >
                {item.label}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default RadioGroup;
